import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuthStore from "./services/AuthStore";

const RoleAccess = ({ roles = [] }) => {
  const { user } = useAuthStore();
  const userRoles = user?.roles?.map(role => role.id) || [];

  const hasAccess =
    roles.length === 0 || roles.some(role => userRoles.includes(role));

  return hasAccess ? <Outlet /> : <Navigate to="/" replace />;
};

export default RoleAccess;
